export default __webpack_public_path__ + "img/vertical-bottom.png";